import * as yup from 'yup';

import { georeferenceSchema } from '../location/validationSchema';

export const GeoReferenceSchema = yup.object().shape({
  georeference: georeferenceSchema,
});
